module.exports = __webpack_public_path__ + "img/help-view.bd4142f.png";


//////////////////
// WEBPACK FOOTER
// ./public/pages/index/assets/img/help-view.png
// module id = 169
// module chunks = 0